import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SanityImage } from "sanity-image";
import type { SanityAsset, SanityImageObject } from "@sanity/image-url";
import { projectConfig } from "../../lib/config";
export const ResponsiveImage: React.FC<{
  image: SanityImageObject;
  alt?: string;
  onClick?: () => void;
  priority?: boolean;
  sizes?: string;
  layout?: "fill" | "responsive" | "cover" | "contain";
}> = t0 => {
  const $ = _c(38);
  const {
    image,
    alt,
    onClick,
    priority,
    sizes,
    layout: t1
  } = t0;
  const layout = t1 === undefined ? "fill" : t1;
  if (!image) {
    return null;
  }
  if (!image.asset) {
    return null;
  }
  const imageId = image.asset?._ref || (image.asset as SanityAsset)._id;
  if (!imageId) {
    return null;
  }
  const {
    projectId,
    dataset
  } = projectConfig;
  const preview = (image as any).asset?.metadata?.lqip;
  const dimensions = (image as any).asset?.metadata?.dimensions;
  const aspectRatio = dimensions ? dimensions.width / dimensions.height : undefined;
  const mode = layout === "cover" ? "cover" : "contain";
  const t2 = layout === "fill" || layout === "cover" ? "100%" : "auto";
  let t3;
  if ($[0] !== mode || $[1] !== t2) {
    t3 = {
      objectFit: mode,
      width: "100%",
      height: t2
    };
    $[0] = mode;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const imageStyle = t3;
  let dimensionProps;
  if ($[3] !== layout) {
    dimensionProps = {};
    if (layout !== "fill" && layout !== "responsive") {
      dimensionProps.width = 800;
    }
    $[3] = layout;
    $[4] = dimensionProps;
  } else {
    dimensionProps = $[4];
  }
  if (layout === "responsive" && aspectRatio) {
    const t4 = `${aspectRatio}`;
    let t5;
    if ($[5] !== t4) {
      t5 = {
        width: "100%",
        aspectRatio: t4,
        display: "block"
      };
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    const containerStyle = t5;
    let t6;
    if ($[7] !== imageStyle) {
      t6 = {
        ...imageStyle,
        height: "100%",
        display: "block"
      };
      $[7] = imageStyle;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    const responsiveImageStyle = t6;
    const t7 = alt || "Image";
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = {
        dpr: typeof window !== "undefined" ? window.devicePixelRatio : 2,
        q: 80
      };
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    const t9 = priority ? "eager" : "lazy";
    const t10 = sizes ?? "(min-width: 1521px) 760px, (min-width: 1181px) 640px, 90vw";
    let t11;
    if ($[10] !== dimensionProps || $[11] !== image.crop || $[12] !== image.hotspot || $[13] !== imageId || $[14] !== mode || $[15] !== onClick || $[16] !== preview || $[17] !== responsiveImageStyle || $[18] !== t10 || $[19] !== t7 || $[20] !== t9) {
      t11 = <SanityImage id={imageId} projectId={projectId} dataset={dataset} mode={mode} preview={preview} hotspot={image.hotspot} crop={image.crop} alt={t7} onClick={onClick} queryParams={t8 as any} loading={t9} sizes={t10} style={responsiveImageStyle} {...dimensionProps} />;
      $[10] = dimensionProps;
      $[11] = image.crop;
      $[12] = image.hotspot;
      $[13] = imageId;
      $[14] = mode;
      $[15] = onClick;
      $[16] = preview;
      $[17] = responsiveImageStyle;
      $[18] = t10;
      $[19] = t7;
      $[20] = t9;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== containerStyle || $[23] !== t11) {
      t12 = <div style={containerStyle}>{t11}</div>;
      $[22] = containerStyle;
      $[23] = t11;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    return t12;
  }
  const t4 = alt || "Image";
  let t5;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      dpr: typeof window !== "undefined" ? window.devicePixelRatio : 2,
      q: 80
    };
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  const t6 = priority ? "eager" : "lazy";
  const t7 = sizes ?? "(min-width: 1521px) 760px, (min-width: 1181px) 640px, 90vw";
  let t8;
  if ($[26] !== dimensionProps || $[27] !== image.crop || $[28] !== image.hotspot || $[29] !== imageId || $[30] !== imageStyle || $[31] !== mode || $[32] !== onClick || $[33] !== preview || $[34] !== t4 || $[35] !== t6 || $[36] !== t7) {
    t8 = <SanityImage id={imageId} projectId={projectId} dataset={dataset} mode={mode} preview={preview} hotspot={image.hotspot} crop={image.crop} alt={t4} onClick={onClick} queryParams={t5 as any} loading={t6} sizes={t7} style={imageStyle} {...dimensionProps} />;
    $[26] = dimensionProps;
    $[27] = image.crop;
    $[28] = image.hotspot;
    $[29] = imageId;
    $[30] = imageStyle;
    $[31] = mode;
    $[32] = onClick;
    $[33] = preview;
    $[34] = t4;
    $[35] = t6;
    $[36] = t7;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  return t8;
};
export default ResponsiveImage;